// DEV_PATH:
// http://localhost:5173/dashboard/control/dictionaries

import { lazy } from "react"
import type { CustomRoute } from "@/shared/types"

const DictionaryComponent = lazy(async () => await import("@/pages/dashboard/control/dictionaries"))

export const controlDictionaryRoutes: CustomRoute = {
  path: "dictionaries",
  handle: {
    label: "Справочники",
    i18Key: "dictionaries"
  },
  Component: DictionaryComponent
}
